import styled from 'styled-components';
import { CDN_URL } from '@karma/utils/constants/env';
import { getColor } from '@karma/components/colors';
import BaseBannerInnerPages from '../../atoms/BaseBannerInnerPages/BaseBannerInnerPages';

export const StyledBanner = styled(BaseBannerInnerPages)`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  height: 100px;
  text-align: center;
  background: url(${CDN_URL}/images/karma/images/hero_background.svg) no-repeat center center;
  background-size: cover;
`;

export const HeroTitle = styled.h1`
  font-weight: 700;
  font-size: 50px;
  line-height: 114%;
  font-family: 'Rebond';
  font-style: normal;
  text-align: center;
  margin: 0px;
  color: ${getColor('primary1')};

  @media (max-width: 576px) {
    font-size: 35px;
  }
`;
